import { makeStyles } from "@material-ui/core";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import ContentTitle from "components/common/ContentTitle";
import TabPanel from "components/common/TabPanel";
import CompanyDocument from "components/company/CompanyDocument";
import CompanyInfo from "components/company/CompanyInfo";
import { SMART_T_STEP } from "libs/constant/Step";
import React from "react";
import { useDispatch } from "react-redux";
import { setSmartFormStep } from "redux/modules/uiSlice";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "0 10px",
  },
  label: {
    alignItems: "flex-start",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
  },
}));

const COMPANY_TAB = {
  COMPANY_INFO: 0,
  COMPANY_DOCUMENT: 1,
};

export default function CompanyTab({ isUploadDoc }) {
  const dispatch = useDispatch();

  const tab = isUploadDoc
    ? COMPANY_TAB.COMPANY_DOCUMENT
    : COMPANY_TAB.COMPANY_INFO;

  return (
    <div>
      <ContentTitle
        title="Application Form"
        subTitle="INSTITUTION/COMPANY APPLYING FOR TEMPORARY STAY FOR FOREIGNER TO STUDY INVESTMENT"
      />
      <div>
        <Tabs value={tab} indicatorColor="primary" textColor="primary">
          <Tab
            label="Company Information"
            style={{ color: "#1094D8" }}
            disabled
          />
          <Tab
            label="Document"
            onClick={() => {
              dispatch(setSmartFormStep(SMART_T_STEP.COMPANY_UPLOAD_DOCUMENT));
            }}
            style={{ color: "#1094D8" }}
            disabled
          />
        </Tabs>
        <TabPanel value={tab} index={COMPANY_TAB.COMPANY_INFO}>
          <CompanyInfo
            onNext={() => {
              dispatch(setSmartFormStep(SMART_T_STEP.COMPANY_UPLOAD_DOCUMENT));
            }}
          />
        </TabPanel>
        <TabPanel value={tab} index={COMPANY_TAB.COMPANY_DOCUMENT}>
          <CompanyDocument onClickBack={() => {}} />
        </TabPanel>
      </div>
    </div>
  );
}
